import { View } from "@Engage.Data/modules/view/View";
/**
 * NewVisitorQualifier
 * Checks whether the user is a new visitor based on total article count across all meter views.
 * Uses getTotalArticleCount() which reads from already-loaded meterViews (available after
 * setViewData(), before setActiveMeterView() — i.e. at qualifier processing time).
 * Returns "yes" if total views <= 1 (new visitor), "no" otherwise.
 */
export class NewVisitorQualifier {
    constructor() {
        this.key = "IsNewVisitor";
    }
    process() {
        try {
            const viewCount = View.getTotalArticleCount();
            return viewCount < 1 ? "true" : "false";
        }
        catch (_a) {
            return "true";
        }
    }
}
